import React from 'react';
import { X, Home, Info, MessageCircle, HelpCircle } from 'lucide-react';

const MatureSidebar = ({ isOpen, setIsOpen }) => {
  const navItems = [
    { 
      label: 'Home', 
      href: '/', 
      icon: Home 
    },
    { 
      label: 'About', 
      href: '#about', 
      icon: Info 
    },
    { 
      label: 'Contact', 
      href: '#contact', 
      icon: MessageCircle 
    },
    { 
      label: 'FAQ', 
      href: '#faq', 
      icon: HelpCircle 
    }
  ];

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 
          transition-opacity duration-300 opacity-100"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div 
        className={`fixed inset-y-0 right-0 w-72 bg-white shadow-2xl z-50 
        transform transition-transform duration-300 ease-in-out 
        ${isOpen 
          ? 'translate-x-0 opacity-100' 
          : 'translate-x-full opacity-0'}`}
      >
        {/* Header */}
        <div 
          className="flex justify-between items-center p-6 border-b border-gray-200 
          bg-gradient-to-r from-indigo-50 to-white"
        >
          <h2 className="text-xl font-semibold text-gray-800">Menu</h2>
          <button 
            onClick={() => setIsOpen(false)}
            className="text-gray-600 hover:text-gray-900 transition-colors"
            aria-label="Close menu"
          >
            <X size={24} />
          </button>
        </div>

        {/* Navigation Links */}
        <nav className="py-4">
          <ul>
            {navItems.map((item) => (
              <li key={item.label}>
                <a 
                  href={item.href}
                  onClick={() => setIsOpen(false)}
                  className="flex items-center px-6 py-4 
                  text-gray-700 hover:bg-gray-100 
                  transition-colors duration-200 group"
                >
                  <item.icon 
                    className="mr-4 text-gray-500 
                    group-hover:text-indigo-600 transition-colors"
                    size={20} 
                  />
                  <span className="font-medium group-hover:text-indigo-600">
                    {item.label}
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Footer */}
        <div 
          className="absolute bottom-0 left-0 right-0 
          p-6 border-t border-gray-200 bg-gray-50 text-center"
        >
          <p className="text-sm text-gray-600">
            © 2025 HireLanka. All Rights Reserved.
          </p>
        </div>
      </div>
    </>
  );
};

export default MatureSidebar;